export const HttpResponseEnum = {
    UNKNOWN_STATUS: 419,
    SERVER_ERROR: 500,
}
